{
  "version": 1,
  "asset_id": "e2809c24-4d8c-4743-82b8-3a1e215b7a7d",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/e2809c24-4d8c-4743-82b8-3a1e215b7a7d/groen-water-1280.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/e2809c24-4d8c-4743-82b8-3a1e215b7a7d/groen-water-1280.avif",
  "original_filename": "groen-water-1280.avif",
  "size": 22983,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:49Z"
}
